import React, { useState, useEffect } from "react";
import useForm from '../../../hooks/useForm';
import { FormField, Button } from '@prosolve/common-components-ui'
import { FaUpload, FaVolumeUp } from 'react-icons/fa';
import UploadBackgroundImageModal from "./UploadBackgroundImageModal";
import BulkGenerateAudioModal from "./BulkGenerateAudioModal";

export default ({
  intro = {},
  backgroundImage,
  isReadOnly,
  onChange,
  assessmentName,
  questions = [],
  onBulkAudioGenerated
}) => {
  const formSchema = {
    optionalFields: ['title', 'subTitle', 'buttonText', 'backgroundImage', 'backgroundImageOrientation', 'teamSelector', 'timeLimit', 'redirectOnCompleteUrl', 'sendEmailOnComplete', 'completionMessage', 'sendEmailOnCompleteToEss', 'largeFonts', 'extraLargeFonts', 'reverseOptions', 'hideIntro', 'isVerticalScrollMode', 'autoPlayAudio'],
    initData: { ...intro, backgroundImage }
  }

  const formData = useForm(formSchema)

  useEffect(() => {
    onChange(formData.values)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values])

  const orientationOptions = [
    { value: 'centered', text: 'Centered'  },
    { value: 'topLeft', text: 'Top Left' },
  ]

  const teamSelectorOptions = [
    { value: '', text: 'None'  },
    { value: 'apex', text: 'Apex' },
    { value: 'starforce', text: 'Starforce' },
  ]

  const [isUploadImagesModalOpen, setIsUploadImagesModalOpen] = useState(false)

  const [isBulkGenerateAudioOpen, setIsBulkGenerateAudioOpen] = useState(false)

  const hasQuestionsWithText = questions.some(({ question }) => question)

  const onUploadedBackgroundImageSuccess = (imageUrl) => {
    if (imageUrl) {
      formData.setValues({ ...formData.values, backgroundImage: imageUrl })    
      setIsUploadImagesModalOpen(false)
    }
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      rowGap: '15px',
    }}>
      {
        isUploadImagesModalOpen &&
        <UploadBackgroundImageModal 
          onClose={() => setIsUploadImagesModalOpen(false)}
          onSuccess={onUploadedBackgroundImageSuccess}
        />
      }
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        columnGap: '15px',
        rowGap: '15px',
      }}>
        <FormField
          fieldId='title'
          type='text'
          label='Title'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='buttonText'
          type='text'
          label='Button Text'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        columnGap: '15px',
        rowGap: '15px',
      }}>
        <FormField
          fieldId='backgroundImage'
          type='text'
          label='Background Image'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Button
            style={{
              display: 'inline-flex',
              padding: '8px 16px',
              marginRight: '20px'
            }}
            onClick={() => setIsUploadImagesModalOpen(true)}
          >
            <FaUpload style={{ marginRight: '10px', color: '#0280c6' }} />
            <span style={{ fontWeight: 'bold', color: '#565656' }}>{'Upload Images'}</span>
          </Button>
        </div>
        <FormField
          fieldId='backgroundImageOrientation'
          type='select'
          label='Background Image Orientation'
          disabled={isReadOnly}
          formData={formData}
          options={orientationOptions}
        />
      </div>
      <FormField
        fieldId='subTitle'
        type='textarea'
        label='Subtitle'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='teamSelector'
        type='select'
        label='Team Selector'
        disabled={isReadOnly}
        formData={formData}
        width='100%'
        options={teamSelectorOptions}
      />
      <FormField
        fieldId='timeLimit'
        type='number'
        label='Time Limit (in minutes)'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='redirectOnCompleteUrl'
        type='text'
        label='Redirect On Complete Url'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='sendEmailOnComplete'
        type='text'
        label='Send on submission notification to the following email address (multiple emails may be added by seperating with commas)'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='completionMessage'
        type='text'
        label='Completion Message'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='sendEmailOnCompleteToEss'
        type='checkbox'
        label='Send email to ESS'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='largeFonts'
        type='checkbox'
        label='Has Large Fonts'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='extraLargeFonts'
        type='checkbox'
        label='Has Extra Large Fonts'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='reverseOptions'
        type='checkbox'
        label='Reverse Order of Answer Options'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='hideIntro'
        type='checkbox'
        label='Hide Intro'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='isVerticalScrollMode'
        type='checkbox'
        label='Enable Vertical Scroll Mode'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='autoPlayAudio'
        type='checkbox'
        label='Auto Play Audio'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      {
        !isReadOnly &&
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'flex-start',
            columnGap: '5px',
            fontSize: '14px',
            color: hasQuestionsWithText ? '#0280c6' : '#7e7e7e',
            cursor: hasQuestionsWithText ? 'pointer' : 'default',
            textDecoration: 'underline'
          }}
          onClick={() => hasQuestionsWithText && setIsBulkGenerateAudioOpen(true)}
        >
          <FaVolumeUp />
          {'Bulk Generate Audio (Text-to-Speech)'}
        </div>
      }
      {
        Boolean(isBulkGenerateAudioOpen) &&
        <BulkGenerateAudioModal
          assessmentName={assessmentName}
          questions={questions}
          onClose={() => setIsBulkGenerateAudioOpen(false)}
          onSuccess={(audioUrlsByQuestionId) => {
            onBulkAudioGenerated(audioUrlsByQuestionId)
            setIsBulkGenerateAudioOpen(false)
          }}
        />
      }
    </div>
  )
}